const F = "#1E3A2B";
const T = "#C86D51";
const A = "#F5E6A3";
const C = "#FAF8F5";
const heart = (x, y, s, fill) => (
  <path transform={`translate(${x} ${y}) scale(${s})`} fill={fill}
    d="M0 6.5C-5.6 2.9-8.4-.1-8.4-3.2c0-2.4 1.8-4.1 4-4.1 1.9 0 3.4 1.1 4.4 2.7 1-1.6 2.5-2.7 4.4-2.7 2.2 0 4 1.7 4 4.1C8.4-.1 5.6 2.9 0 6.5z" />
);
const line = { fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };

const Original = ({ light }) => (
  <>
    <circle cx="24" cy="24" r="23" fill={light ? C : F} />
    <path d="M24 11c-5.4 5-8.4 10.3-8.4 15.1 0 4.8 3.7 8.9 8.4 8.9s8.4-4.1 8.4-8.9C32.4 21.3 29.4 16 24 11z" fill={T} />
    <path d="M24 18v18" stroke={light ? F : C} strokeWidth="1.9" strokeLinecap="round" />
    <circle cx="24" cy="25" r="2.2" fill={light ? F : C} />
  </>
);

const HeartHome = ({ light }) => (
  <>
    <path d="M6 23 24 8l18 15" stroke={light ? C : F} strokeWidth="3.4" {...line} />
    <path d="M11 20v18.5a2.5 2.5 0 0 0 2.5 2.5h21a2.5 2.5 0 0 0 2.5-2.5V20" stroke={light ? C : F} strokeWidth="3.4" {...line} />
    {heart(24, 29, 1.15, T)}
  </>
);

const DoorwayBadge = ({ light }) => (
  <>
    <circle cx="24" cy="24" r="23" fill={light ? C : F} />
    <path d="M11.5 24.5 24 13.5l12.5 11V36h-25z" fill={light ? F : C} />
    <rect x="30" y="14" width="3.2" height="7" rx="1" fill={light ? F : C} />
    <path d="M20.5 36v-6.5a3.5 3.5 0 0 1 7 0V36z" fill={A} />
    {heart(24, 22.6, 0.5, T)}
  </>
);

const OpenDoor = ({ light }) => (
  <>
    <path d="M12 41V21a12 12 0 0 1 24 0v20z" fill={light ? C : F} />
    <path d="M17 41V22a7 7 0 0 1 14 0v19z" fill={A} />
    {heart(24, 30, 0.75, T)}
    <path d="M7 41h34" stroke={light ? C : F} strokeWidth="2.6" strokeLinecap="round" />
  </>
);

const Neighbourhood = ({ light }) => (
  <>
    <path d="M3 41V29l7-6 7 6v12z" fill={T} />
    <path d="M14 41V21l10-9 10 9v20z" fill={light ? C : F} />
    <path d="M31 41V29l7-6 7 6v12z" fill={A} />
    {heart(24, 26, 0.7, light ? F : C)}
    <path d="M1.5 41h45" stroke={light ? C : F} strokeWidth="2.2" strokeLinecap="round" />
  </>
);

const PenHome = ({ light }) => (
  <>
    <path d="M24 5 39 19v5L27.5 43h-7L9 24v-5z" fill={light ? C : F} />
    {heart(24, 21.5, 0.8, A)}
    <path d="M24 28v13" stroke={light ? F : C} strokeWidth="1.8" strokeLinecap="round" />
  </>
);

const Embrace = ({ light }) => (
  <>
    <path d="M24 43C11.5 35 5 27.5 5 19c0-6 4.6-10.5 10.2-10.5 4 0 7 2.4 8.8 5.6 1.8-3.2 4.8-5.6 8.8-5.6C38.4 8.5 43 13 43 19c0 8.5-6.5 16-19 24z" stroke={T} strokeWidth="3.2" {...line} />
    <path d="M16 28.5 24 21.5l8 7V36H16z" fill={light ? C : F} />
    <rect x="22" y="30.5" width="4" height="5.5" rx="1" fill={A} />
  </>
);

export const MARKS = {
  original: { name: "Current mark", desc: "Leaf/pen-nib emblem currently on the site.", Svg: Original },
  "heart-home": { name: "1. Heart Home", desc: "A simple house outline with a heart at its centre: home, comfort and care.", Svg: HeartHome },
  "doorway-badge": { name: "2. Welcome Home Badge", desc: "A round badge with a house, a warm lit doorway and a small heart above the door.", Svg: DoorwayBadge },
  "open-door": { name: "3. Open Door", desc: "An arched doorway glowing with warm light and a heart: always welcome here.", Svg: OpenDoor },
  neighbourhood: { name: "4. Neighbourhood", desc: "Three homes side by side, the centre one with a heart: a caring community.", Svg: Neighbourhood },
  "pen-home": { name: "5. Pen & Home", desc: "A pen nib shaped like a house with a heart: a nod to the Friendship Pen name.", Svg: PenHome },
  embrace: { name: "6. Embrace", desc: "A heart wrapping around a small house: protection, warmth and belonging.", Svg: Embrace },
};

export const LogoMark = ({ mark = "original", light = false, size = 38 }) => {
  const { Svg } = MARKS[mark];
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
      <Svg light={light} />
    </svg>
  );
};
